import React, { Component } from 'react';
import SupplierAccess from '../components/SupplierAccess';
import RoleUtils from '../utils/roleUtils.js';
import ServiceCalls from '../utils/serviceCalls.js';
import { Loading } from '../components/Loading';
import '../styles/Search.css';

export class MaintainAccess extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hasAccess: false,
            pending: true
        }
    }

    componentDidMount() {
        const { currentUser,currentCompanyId } = this.props;
        ServiceCalls.checkSupplierAccess(currentCompanyId).then(function (data) {
            if (data) {
                if (data === false) {
                    this.setState({ hasAccess: false,pending:false });
                }
                else {
                    var mpaPerms = RoleUtils.maintainPortalAccessPerms();
                    var canAccess = RoleUtils.canAccess(currentUser, currentCompanyId, mpaPerms);
                    if (!canAccess) {
                        this.setState({ hasAccess: false, pending: false });
                    }
                    else if (!this.state.hasAccess && canAccess) {
                        this.setState({ hasAccess: true, pending: false });
                    }
                }
            }
            else {
                this.setState({ hasAccess: false, pending: false });
            }
        }.bind(this));        
    }

    componentDidUpdate(prevProps) {
        const { currentUser, currentCompanyId } = this.props;
        if (prevProps.currentCompanyId !== currentCompanyId) {   
            this.setState({
                hasAccess: false,
                pending: true
            });

            ServiceCalls.checkSupplierAccess(currentCompanyId).then(function (data) {
                if (data) {
                    if (data === false) {
                        this.setState({ hasAccess: false, pending: false });
                    }
                    else {
                        var mpaPerms = RoleUtils.maintainPortalAccessPerms();
                        var canAccess = RoleUtils.canAccess(currentUser, currentCompanyId, mpaPerms);
                        if (!canAccess) {
                            this.setState({ hasAccess: false, pending: false });
                        }
                        else if (!this.state.hasAccess && canAccess) {
                            this.setState({ hasAccess: true, pending: false });
                        }
                    }
                }
                else {
                    this.setState({ hasAccess: false, pending: false });
                }
            }.bind(this)); 
        }
    }

    render() {
        if (this.state.pending) {
            return (
                <div style={{ margin: "auto", width: "250px" }}>
                    <h3 className="primaryText">Portal Access</h3>
                    <Loading />
                </div>);
        } 
        else if (!this.state.hasAccess) {
            return (
                <h3 style={{marginTop:"10px"}}>You do not have access rights to this page.</h3>
            );
        }
        return (
            <SupplierAccess currentUser={this.props.currentUser} currentCompanyId={this.props.currentCompanyId}/>
    );
  }
}
